//  Angular imports
import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationRoute } from 'app/models/application-route';
import { UserService } from 'app/services/user.service';
import versionJson from '../../../../version.json';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'zf-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [NgClass, NgIf]
})
export class SidebarComponent {
    router = inject(Router);
    userService = inject(UserService);

    public readonly version: string = versionJson.version;
    public readonly fullVersion: string = versionJson.fullVersion;

    public readonly serialNumber = input<string>('');

    public readonly route: typeof ApplicationRoute = ApplicationRoute;

    public get isAccountSelection(): boolean {
        return this.hasRoute(ApplicationRoute.ACCOUNT_SELECTION);
    }

    public get isEntitlements(): boolean {
        return this.hasRoute(ApplicationRoute.ENTITLEMENTS);
    }

    public navigateEntitlements(): void {
        this.router.navigateByUrl(ApplicationRoute.ENTITLEMENTS);
    }

    private hasRoute(route: ApplicationRoute): boolean {
        return this.router.url.includes(route);
    }
}
